
export default function ScholarshipsSection() {
  const scholarships = [
    {
      title: 'CPVA Excellence Award',
      amount: '$5,000',
      description: 'Recognizing outstanding academic achievement and leadership in integrative healthcare',
      eligibility: 'GPA 3.7+, Leadership experience',
      deadline: 'March 15, 2024'
    },
    {
      title: 'One Health Innovation Grant',
      amount: '$3,000',
      description: 'Supporting research projects that bridge human and animal health',
      eligibility: 'Research proposal required',
      deadline: 'April 30, 2024'
    },
    {
      title: 'Rural Healthcare Scholarship',
      amount: '$2,500',
      description: 'For students committed to serving rural and underserved communities',
      eligibility: 'Rural service commitment',
      deadline: 'February 28, 2024'
    },
    {
      title: 'Indigenous Student Award',
      amount: '$4,000',
      description: 'Supporting Indigenous students in pharmacy and veterinary programs',
      eligibility: 'Indigenous heritage',
      deadline: 'January 31, 2024'
    },
    {
      title: 'International Exchange Grant',
      amount: '$2,000',
      description: 'Funding for international study opportunities and cultural exchange',
      eligibility: 'Exchange program enrollment',
      deadline: 'Rolling basis'
    },
    {
      title: 'Research Publication Award',
      amount: '$1,500',
      description: 'Recognizing student research published in peer-reviewed journals',
      eligibility: 'Published research paper',
      deadline: 'December 1, 2024'
    }
  ];

  return (
    <section className="py-16 bg-gradient-to-br from-blue-50 to-indigo-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Scholarships & Awards
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            CPVA is committed to supporting student success through financial assistance and recognition programs. Over $50,000 in scholarships awarded annually.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {scholarships.map((scholarship, index) => (
            <div key={index} className="bg-white rounded-lg p-6 shadow-lg hover:shadow-xl transition-shadow">
              <div className="flex items-center justify-between mb-4">
                <div className="w-12 h-12 bg-yellow-100 rounded-full flex items-center justify-center">
                  <i className="ri-award-line text-2xl text-yellow-600"></i>
                </div>
                <div className="text-2xl font-bold text-green-600">
                  {scholarship.amount}
                </div>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {scholarship.title}
              </h3>
              <p className="text-gray-600 mb-4">
                {scholarship.description}
              </p>
              <div className="space-y-2 text-sm">
                <div className="flex items-center text-gray-700">
                  <i className="ri-user-line text-blue-500 mr-2"></i>
                  <span className="font-medium">Eligibility:</span>
                  <span className="ml-1">{scholarship.eligibility}</span>
                </div>
                <div className="flex items-center text-gray-700">
                  <i className="ri-calendar-line text-red-500 mr-2"></i>
                  <span className="font-medium">Deadline:</span>
                  <span className="ml-1">{scholarship.deadline}</span>
                </div>
              </div>
              <button className="w-full mt-4 bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer">
                Apply Now
              </button>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-white rounded-lg p-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            <div>
              <div className="text-3xl font-bold text-blue-600 mb-2">$50,000+</div>
              <div className="text-gray-600">Annual Scholarships</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-green-600 mb-2">150+</div>
              <div className="text-gray-600">Recipients Last Year</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-purple-600 mb-2">95%</div>
              <div className="text-gray-600">Graduate Employment</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
